import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/Button';
import { Card } from '../components/Card';
import { authAPI } from '../lib/auth-api';
import { useAuth } from '../hooks/useAuth';

const DEV_MODE = import.meta.env.MODE === 'development';

export function Login() {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading } = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, navigate]);

  const handleDevBypass = () => {
    window.location.href = '/?bypass_auth';
  };

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <h1 className="mb-4"><img src="/varinym-logo.png" alt="Varinym" className="h-12 mx-auto" /></h1>
          <h2 className="text-2xl font-semibold text-foreground mb-2">Admin Console</h2>
          <p className="text-muted-foreground">Identity Alias & Masking System</p>
        </div>

        <Card>
          <div className="space-y-6">
            <div>
              <h3 className="text-lg font-medium text-card-foreground mb-2">Welcome</h3>
              <p className="text-sm text-muted-foreground">
                Sign in with your AWS Cognito account to access the admin console.
              </p>
            </div>

            <Button onClick={() => authAPI.login()} className="w-full">
              Sign In with AWS Cognito
            </Button>

            {DEV_MODE && (
              <div className="pt-4 border-t border-border">
                <Button
                  onClick={handleDevBypass}
                  variant="secondary"
                  className="w-full"
                >
                  Development Bypass
                </Button>
                <p className="mt-2 text-xs text-muted-foreground text-center">
                  Development mode only - bypasses authentication
                </p>
              </div>
            )}

            <div className="text-xs text-muted-foreground space-y-2">
              <p className="font-medium text-foreground">What is Varinym?</p>
              <ul className="list-disc list-inside space-y-1 ml-2">
                <li>Create masked identities for users</li>
                <li>Generate temporary alias tokens</li>
                <li>Manage context-specific identity tokens</li>
                <li>Process bulk operations with CSV uploads</li>
              </ul>
            </div>
          </div>
        </Card>

        <div className="mt-8 text-center text-sm text-muted-foreground">
          <p>Protected by multi-tenant authentication</p>
          <p className="mt-1">Powered by Cloudflare Workers</p>
        </div>
      </div>
    </div>
  );
}
